import { IconProps } from '@mui/material';
import { forwardRef } from 'react';

import IconWrapper from '../../wrappers/IconWrapper';

export type AtomIconSize = 'inherit' | 'small' | 'medium' | 'large';

export interface IAtomIconProps extends Omit<IconProps, 'fontSize'> {
  size?: AtomIconSize;
}

const AtomIcon = forwardRef<HTMLSpanElement, IAtomIconProps>(({ size, color, children, ...props }, ref) => (
  <IconWrapper ref={ref} fontSize={size} color={color} {...props}>
    {children}
  </IconWrapper>
));

AtomIcon.displayName = 'AtomIcon';

export default AtomIcon;
